import {createReducer, on} from '@ngrx/store';
import {DeleteDialogActions} from '../actions/delete-dialog.actions';
import {DeleteDialogState} from '../states/delete-dialog.state';

export const initialDeleteDialogState: DeleteDialogState = {
  isOpen: false,
  belegIds: [],
};

export const deleteDialogReducer = createReducer(
  initialDeleteDialogState,

  on(DeleteDialogActions.open, (state, {belegIds}) => ({
    ...state,
    isOpen: true,
    belegIds,
  })),

  on(DeleteDialogActions.close, state => ({
    ...state,
    isOpen: false,
    belegIds: [],
  })),
);
